var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 358,
    height: 207,
    viewBox: "0 0 358 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 358,
    height: 207,
    transform: "translate(29 375)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.265,
    cy: 5.265,
    r: 5.265,
    transform: "translate(26.534 7.581)",
    fill: "#243553"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 10.529,
    height: 10.529,
    transform: "translate(26.534 7.581)",
    fill: "#243553"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.265,
    cy: 5.265,
    r: 5.265,
    transform: "translate(25.271 6.318)",
    fill: "#243553",
    stroke: "#707070",
    strokeWidth: 0.421
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_44",
    "data-name": "Mask Group 44",
    transform: "translate(-29 -375)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(-985.193 -825.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(863.412 1094.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "magnifying-glass-solid",
    d: "M8.554,4.277A4.267,4.267,0,0,1,7.732,6.8l2.6,2.605a.659.659,0,1,1-.932.932L6.8,7.732A4.277,4.277,0,1,1,8.554,4.278ZM4.277,7.238A2.961,2.961,0,1,0,1.316,4.277,2.961,2.961,0,0,0,4.277,7.238Z",
    transform: "translate(26.535 7.581)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Discover",
    transform: "translate(281.285 169.629)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Discover"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(950.174 1095.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-2",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "message-code-solid",
    d: "M0,0H10.529V8.555H6.252L3.291,10.529V8.555H0ZM4.464,3.311l.35-.35-.7-.7-.35.35L2.447,3.93l-.35.35.35.35L3.764,5.945l.35.35.7-.7-.35-.35L3.5,4.277l.967-.967Zm2.3-.7-.35-.35-.7.7.35.35.965.967-.967.967-.35.35.7.7.35-.35L8.08,4.625l.35-.35-.35-.35Z",
    transform: "translate(26.534 7.581)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Continuous_",
    "data-name": "Continuous ",
    transform: "translate(276.851 166.786)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Continuous ")), /*#__PURE__*/React.createElement("text", {
    id: "feedback",
    transform: "translate(279.867 173.525)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "feedback")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(1048.729 1065.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-3",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-3",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-3",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-3",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(1.264 1.264)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-solid",
    d: "M5.265.7A5.143,5.143,0,0,0,1.744,2.176a7.244,7.244,0,0,0-1.7,2.4.581.581,0,0,0,0,.45,7.244,7.244,0,0,0,1.7,2.4A5.143,5.143,0,0,0,5.265,8.893,5.143,5.143,0,0,0,8.785,7.419a7.3,7.3,0,0,0,1.7-2.4.581.581,0,0,0,0-.45,7.279,7.279,0,0,0-1.7-2.4A5.143,5.143,0,0,0,5.265.7ZM2.632,4.8A2.632,2.632,0,1,1,5.264,7.428,2.632,2.632,0,0,1,2.632,4.8Zm2.632-1.17A1.171,1.171,0,0,1,4.095,4.8a1.187,1.187,0,0,1-.371-.06.156.156,0,0,0-.214.135,1.7,1.7,0,0,0,.059.379A1.755,1.755,0,1,0,5.339,3.042a.155.155,0,0,0-.135.214,1.187,1.187,0,0,1,.06.371Z",
    transform: "translate(25.27 6.786)",
    fill: "#243553",
    stroke: "#707070",
    strokeWidth: 0.022
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Observe",
    transform: "translate(280.864 170.892)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Observe"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(753.906 1065.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-4",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-4",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-4",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-4",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pen-nib-solid",
    d: "M7.594.379,6.439,1.536,9.034,4.13l1.154-1.154a1.16,1.16,0,0,0,0-1.643L9.236.379a1.159,1.159,0,0,0-1.643,0ZM5.928,1.961l-.191.058-2.987.9a1.325,1.325,0,0,0-.877.85L.037,9.239a.662.662,0,0,0,.151.671L3.372,6.729A1,1,0,1,1,3.84,7.2L.657,10.382a.658.658,0,0,0,.671.151L6.806,8.7a1.33,1.33,0,0,0,.85-.877L8.55,4.833l.058-.191Z",
    transform: "translate(26.533 7.542)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Plan",
    transform: "translate(286.142 170.05)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Plan"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(753.906 1157.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-5",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-5",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-5",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-5",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "code-solid",
    d: "M6.463.02a.527.527,0,0,0-.651.362L3.706,7.752a.527.527,0,0,0,1.011.292L6.823.674A.527.527,0,0,0,6.463.02ZM7.789,2a.527.527,0,0,0,0,.745l1.469,1.47L7.788,5.683a.527.527,0,1,0,.745.745l1.843-1.843a.527.527,0,0,0,0-.745L8.533,2a.527.527,0,0,0-.745,0ZM2.743,2A.527.527,0,0,0,2,2L.155,3.839a.527.527,0,0,0,0,.745L2,6.427a.527.527,0,0,0,.745-.745L1.272,4.212,2.743,2.741a.527.527,0,0,0,0-.745Z",
    transform: "translate(26.534 8.634)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Build",
    transform: "translate(285.234 170.892)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Build"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(863.412 1222.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-6",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-6",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-6",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-6",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gear-solid",
    d: "M9.912,3.427a.466.466,0,0,1-.132.505l-.636.579a.73.73,0,0,0-.224.574c0,.06,0,.119,0,.181s0,.121,0,.181a.716.716,0,0,0,.224.574l.636.578a.466.466,0,0,1,.132.505,5.1,5.1,0,0,1-.325.705l-.1.168a5.234,5.234,0,0,1-.454.642.466.466,0,0,1-.505.14L7.714,8.5A.725.725,0,0,0,7.1,8.6a3.574,3.574,0,0,1-.31.179.733.733,0,0,0-.387.481l-.183.837a.463.463,0,0,1-.374.366,5.343,5.343,0,0,1-1.748,0,.463.463,0,0,1-.374-.366l-.183-.837a.727.727,0,0,0-.384-.484c-.107-.056-.211-.115-.31-.179A.724.724,0,0,0,2.238,8.5l-.815.261a.47.47,0,0,1-.505-.14,5.234,5.234,0,0,1-.454-.641l-.1-.168a5.1,5.1,0,0,1-.324-.7A.466.466,0,0,1,.174,6.6l.634-.578a.73.73,0,0,0,.224-.574c0-.06,0-.119,0-.181s0-.121,0-.181a.716.716,0,0,0-.224-.574l-.636-.58a.466.466,0,0,1-.131-.506,5.1,5.1,0,0,1,.324-.705l.1-.168a5.234,5.234,0,0,1,.454-.64.466.466,0,0,1,.505-.14l.817.259a.725.725,0,0,0,.609-.095,3.574,3.574,0,0,1,.31-.179.733.733,0,0,0,.387-.481L3.73.44A.463.463,0,0,1,4.1.074,5.1,5.1,0,0,1,4.978,0a5.315,5.315,0,0,1,.874.072.463.463,0,0,1,.374.366l.183.837a.721.721,0,0,0,.387.481c.107.056.211.115.31.179a.732.732,0,0,0,.611.095l.817-.262a.47.47,0,0,1,.505.14,5.234,5.234,0,0,1,.454.642l.1.168a5.1,5.1,0,0,1,.325.705ZM4.978,6.911A1.646,1.646,0,1,0,3.332,5.265,1.646,1.646,0,0,0,4.978,6.911Z",
    transform: "translate(26.822 7.581)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Test",
    transform: "translate(286.036 170.05)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Test"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(950.174 1222.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-7",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-7",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-7",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-7",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "paper-plane-solid",
    d: "M0,5.923,10.529,0,9.213,9.872,5.591,8.319,4.277,10.529,3.29,10.2V7.9L7.9,3.291,2.735,7.1Z",
    transform: "translate(26.534 7.581)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Deploy",
    transform: "translate(282.745 170.05)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Deploy"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(1048.729 1157.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7-8",
    "data-name": "Group 7",
    transform: "translate(260.287 137.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-8",
    "data-name": "Rectangle 14",
    transform: "translate(0 12.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.176,
    height: 29.482,
    rx: 4.212,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.211,
    width: 62.755,
    height: 29.061,
    rx: 4.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-8",
    "data-name": "Group 6",
    transform: "translate(17.268 -0.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-8",
    "data-name": "Ellipse 2",
    transform: "translate(5.054 4.212)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.421
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.476,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.476,
    cy: 9.476,
    r: 9.266,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wrench-solid",
    d: "M7.239,6.581a3.289,3.289,0,0,0,3.29-3.29,3.324,3.324,0,0,0-.126-.909.295.295,0,0,0-.5-.107L8.323,3.854a.33.33,0,0,1-.232.1H6.911a.33.33,0,0,1-.329-.329V2.442a.33.33,0,0,1,.1-.232L8.258.63a.295.295,0,0,0-.11-.5,3.294,3.294,0,0,0-4,4.285L.409,8.146A1.4,1.4,0,1,0,2.384,10.12L6.118,6.386A3.268,3.268,0,0,0,7.239,6.581ZM1.646,8.392a.491.491,0,1,1-.35.144.494.494,0,0,1,.35-.144Z",
    transform: "translate(26.534 7.581)",
    fill: "#243553"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Operate",
    transform: "translate(281.383 170.05)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Acumin Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Operate"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(866.149 1047.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M3.159,0,6.318,8.424H0Z",
    transform: "translate(220.065 339.468) rotate(90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(179.632 289.769)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 52.858,
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 78.128,
    transform: "translate(0 52.858)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(863.412 1047.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M3.159,0,6.318,8.424H0Z",
    transform: "translate(409.699 184.618) rotate(-90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25-2",
    "data-name": "Group 25",
    transform: "translate(445.605 181.527) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    y2: 67.072,
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 7.265,
    transform: "translate(0 67.072)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(863.412 1047.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    d: "M3.159,0,6.318,8.424H0Z",
    transform: "translate(251.864 184.475) rotate(-90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25-3",
    "data-name": "Group 25",
    transform: "translate(291.875 188.687) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    y2: 7.16,
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 78.128,
    transform: "translate(0 7.16)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(863.412 1047.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    d: "M3.159,0,6.318,8.424H0Z",
    transform: "translate(339.889 336.941) rotate(90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 23.586,
    transform: "translate(323.674 340.1)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(999.932 1622.656) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-6",
    "data-name": "Polygon 1",
    d: "M3.989,0,7.978,8.424H0Z",
    transform: "translate(355.492 336.941) rotate(90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-6",
    "data-name": "Line 4",
    x2: 53.948,
    transform: "translate(323.674 340.93)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(1386.711 921.286) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-7",
    "data-name": "Polygon 1",
    d: "M3.989,0,7.978,8.424H0Z",
    transform: "translate(355.492 336.941) rotate(90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-7",
    "data-name": "Line 4",
    x2: 53.948,
    transform: "translate(323.674 340.93)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(983.412 1569.136) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-8",
    "data-name": "Polygon 1",
    d: "M3.159,0,6.318,8.424H0Z",
    transform: "translate(208.066 355.122) rotate(90)",
    fill: "#f7dd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25-4",
    "data-name": "Group 25",
    transform: "translate(179.632 289.769)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    y2: 68.511,
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-8",
    "data-name": "Line 4",
    x2: 52.269,
    transform: "translate(0 68.511)",
    fill: "none",
    stroke: "#f7dd95",
    strokeWidth: 0.421
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.3b379b80e988c9f8930d35a6403f716f.svg";
export { ForwardRef as ReactComponent };